import React, { memo } from 'react';
// import * as styles from './Spinner.module.css';

const sizeMap = {
  small: 32,
  medium: 64,
  large: 128,
};

const defaultSize = 64;

const getSize = size => sizeMap[size] || defaultSize;

const getStyle = size => ({
  width: getSize(size),
  height: getSize(size),
});

const Spinner = ({ size }) => (
  <div style={getStyle(size)}>
    <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
      <circle cx="50" cy="50" fill="none" r="40" stroke="#34495e" strokeWidth="5"></circle>
      <path d="M 15 50 Q 32.5 56.7759 50 50 Q 67.5 43.2241 85 50 A 35 35 0 0 1 15 50" fill="#3498db">
        <animate attributeName="d" calcMode="spline" values="M15 50 Q32.5 40 50 50 Q67.5 60 85 50 A35 35 0 0 1 15 50;M15 50 Q32.5 60 50 50 Q67.5 40 85 50 A35 35 0 0 1 15 50;M15 50 Q32.5 40 50 50 Q67.5 60 85 50 A35 35 0 0 1 15 50" keyTimes="0;0.5;1" dur="1.2" keySplines="0.5 0 0.5 1;0.5 0 0.5 1" begin="0s" repeatCount="indefinite"></animate>
      </path>
    </svg>
  </div>
);

export default memo(Spinner);
